import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import sentGAEvent from '@/ga';
import { request } from '@/api/request';
import Upload from '../../upload/Upload';
import actions from '@/redux/action';
import Utils from '@/utils';
import moment from 'moment';
import VideoCompressWorkContentFunction from './children/videoCompressWorkContentFunction/VideoCompressWorkContentFunction';
import VideoCompressWorkFinishFunction from './children/videoCompressWorkFinishFunction/VideoCompressWorkFinishFunction';
import TipSimpleModal from '@/components/common/tipSimpleModal/TipSimpleModal';
import { api_config } from '@/constants/api';
import Cookies from 'js-cookie';
import api_domain_config from '@/constants/common';
import { accountList } from '@/constants/url';
import '@/assets/videoCompress.less';

class VideoCompressWork extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videoAccept:
        '.mkv,.mov,.mp4,.avi,.wmv,.vob,.webm,.asf,.f4v,.flv,.mpg,.mpeg,.ts,.mxf,.ogv,.swf',
      submitStatus: 'waiting',
      resolution: 'original',
      format: 'mp4',
      quality: 80,
      frameRate: 5,
      submitting: false,
      processText: 'Uploading',
      uploadFail: false,
    };
    this.cancelWork = false;
  }

  handleVideoCompressObjChange = (videoCompressObj) => {
    this.props.onVideoCompressObjChange(videoCompressObj);
  };

  addFileCallBack = (videoCompressObj) => {
    this.handleUpload(videoCompressObj);
    this.props.onVideoCompressObjChange(videoCompressObj);
  };

  handleSubmit = async () => {
    let flag = Utils.handleVideoEditorTimes('24VC');
    if (flag) {
      return false;
    }
    const startSubmitTime = new Date().valueOf();
    // const startTime = {...this.props.startTime}
    // startTime.videoCompress = startSubmitTime
    // this.props.onStartTimeChange(startTime);
    this.cancelWork = false;
    this.setState({
      submitting: true,
      processText: this.props.t('Compressing'),
    });
    this.props.onProcessStepChange(1);
    this.props.onProcessPercentChange(1);
    const videoCompressObj = { ...this.props.videoCompressObj };
    let workResponse;
    try {
      workResponse = await this.requstVideoCompress(
        videoCompressObj.videofileurl,
        this.getRequestData()
      );
    } catch (error) {
      if (error !== 'cancel') {
        sentGAEvent({
          category: 'compress_fail',
          action: 'compress_fail',
          label: 'compressVideo_none_none_' + this.props.tokenId + '_none_none',
        });
      }
      this.handleSubmitFail(error);
      return false;
    }
    if (this.cancelWork) {
      this.handleSubmitFail('cancel');
      return false;
    }
    if (workResponse.code === 200) {
      if (workResponse.data.result.number) {
        sentGAEvent({
          category: 'ProcessStart',
          action: '24VC_ProcessStart',
          label: 'Null',
        });
        const workResponseNumber = workResponse.data.result.number;
        let progressResponse;
        try {
          progressResponse = await Utils.getProgress(workResponseNumber, false);
        } catch (error) {
          if (error !== 'cancel') {
            sentGAEvent({
              category: 'compress_fail',
              action: 'compress_fail',
              label: 'compressVideo' + '_200_200_' + error,
            });
          }
          this.handleSubmitFail(error);
          return false;
        }
        if (
          parseFloat(progressResponse.info[0].size) >
          this.props.videoCompressObj.size
        ) {
          this.handleSubmitFail();
          sentGAEvent({
            category: 'compress_fail',
            action: 'compress_fail',
            label: 'compress video bigger than orignal video',
          });
          return false;
        }
        this.sentGaOfSubmitSuccess({
          startTime: startSubmitTime,
          size: parseFloat(progressResponse.info[0].size),
          fps: progressResponse.info[0].fps,
          wh: progressResponse.info[0].wh,
          tbr: progressResponse.info[0].bit_rate,
        });
        const videoCompressAfter = {
          name:
            moment(new Date()).format('YYYYMMDDHHmmss') +
            '.' +
            this.state.format,
          size: parseFloat(progressResponse.info[0].size),
          downloadurl: progressResponse.info[0].url,
          duration: moment('00:00:00', 'mm:ss:SS')
            .add(
              parseFloat(parseFloat(progressResponse.info[0].duration)),
              'seconds'
            )
            .format('mm:ss:SS')
            .replace(/:([^:]*)$/, '.$1'),
          format: this.state.format,
        };
        this.setState({
          submitting: false,
          submitStatus: 'success',
          videoCompressAfter,
        });
        sentGAEvent({
          category: 'ProcessSuccess',
          action: '24VC_ProcessSuccess',
          label: 'Null',
        });
        this.props.onProcessPercentChange(0);
        this.props.onProcessStepChange(0);
        this.props.onUploadPercentChange(0);
      }
    } else {
      sentGAEvent({
        category: 'compress_fail',
        action: 'compress_fail',
        label:
          'compressVideo' +
          '_200_' +
          workResponse.code +
          '_none_' +
          this.props.tokenId +
          '_none_' +
          workResponse.msg,
      });
      if (workResponse.code === 402102) {
        this.props.onPurchaseModalObjChange({
          visible: true,
          type: 'videoEditorTimesMoreThanLimit',
        });
        sentGAEvent({
          category: 'UpgradePrompShow',
          action: '24VC_UpgradePrompShow',
        });
        this.handleSubmitFail('cancel');
      } else {
        this.handleSubmitFail();
      }

      return false;
    }
  };

  sentGaOfSubmitSuccess = ({ startTime, size, fps, wh, tbr }) => {
    console.log(this.props.videoCompressObj.size);
    sentGAEvent({
      category: 'compress_output',
      action: 'compress_output_duration',
      label: new Date().valueOf() - startTime + 'ms',
    });
    sentGAEvent({
      category: 'compress_output',
      action: 'compress_output_size',
      label: `${(this.props.videoCompressObj.size / 1024).toFixed(2)}kb_${(
        size / 1024
      ).toFixed(2)}kb`,
    });
    sentGAEvent({
      category: 'compress_output',
      action: 'compress_output_resolution',
      label: `${
        parseInt(this.props.videoCompressObj.width) *
        parseInt(this.props.videoCompressObj.height)
      }_${parseInt(wh.split('x')[0]) * parseInt(wh.split('x')[1])}`,
    });
    sentGAEvent({
      category: 'compress_output',
      action: 'compress_output_framerate',
      label: `${this.props.videoCompressObj.frameRate}_${fps}`,
    });
    sentGAEvent({
      category: 'compress_output',
      action: 'compress_output_bitrate',
      label: `${this.props.videoCompressObj.bitrate}_${tbr}`,
    });
    if (this.props.videoCompressObj.size > size) {
      sentGAEvent({
        category: 'compress_success',
        action: 'compress_success',
        label: `${(
          ((this.props.videoCompressObj.size - size) /
            this.props.videoCompressObj.size) *
          100
        ).toFixed(2)}%`,
      });
    }
  };

  handleUpload = async (videoCompressObj) => {
    let startUploadTime = new Date().valueOf();
    const startTime = { ...this.props.startTime };
    startTime.upload = startUploadTime;
    this.props.onStartTimeChange(startTime);
    this.cancelWork = false;
    this.setState({ submitting: true, processText: 'Uploading' });
    this.props.onProcessStepChange(2);
    if (!videoCompressObj.uploadStatus) {
      let fileResponse;
      try {
        fileResponse = await this.requestUploadVideoFile(
          videoCompressObj.fileObj
        );
      } catch (error) {
        if (error !== 'cancel') {
          sentGAEvent({
            category: 'Upload',
            action: 'LocalSerFail',
            label: error + '_none_none_' + this.props.tokenId + '_none_none',
          });
          sentGAEvent({
            category: 'compress_add_files',
            action: 'compress_add_files_fail',
            label: `${(videoCompressObj.size / 1024).toFixed(2)}mb_${
              videoCompressObj.name.split('.')[
                videoCompressObj.name.split('.').length - 1
              ]
            }`,
          });
        }
        this.handleSubmitFail(error, 'upload');
        return false;
      }
      if (this.cancelWork) {
        this.handleSubmitFail('cancel', 'upload');
        return false;
      }
      if (fileResponse.code === 200) {
        if (fileResponse.data.result.number) {
          const fileResponseNumber = fileResponse.data.result.number;
          const fileResponseUrl = fileResponse.data.response_file[0];
          let fileProcess;
          try {
            fileProcess = await Utils.getProgress(fileResponseNumber, false);
            sentGAEvent({
              category: 'UploadSuccess',
              action: '24VC_UploadSuccess',
              label: 'Null',
            });
          } catch (error) {
            if (error !== 'cancel') {
              sentGAEvent({
                category: 'Upload',
                action: 'LocalSerFail',
                label: 'uploadVideo' + '_200_200_' + error,
              });
              sentGAEvent({
                category: 'compress_add_files',
                action: 'compress_add_files_fail',
                label: `${(videoCompressObj.size / 1024).toFixed(2)}kb_${
                  videoCompressObj.name.split('.')[
                    videoCompressObj.name.split('.').length - 1
                  ]
                }`,
              });
            }
            this.handleSubmitFail(error);
            return false;
          }
          videoCompressObj.videofileurl = fileResponseUrl;
          videoCompressObj.status = 'uploaded';
          videoCompressObj.uploadStatus = true;
          videoCompressObj.frameRate = Number(
            fileProcess.info[0].fps.toFixed(2)
          );
          videoCompressObj.bitrate = fileProcess.info[0].bit_rate;
          videoCompressObj.size = parseInt(fileProcess.info[0].size);
          videoCompressObj.width = fileProcess.info[0].wh.substring(
            0,
            fileProcess.info[0].wh.indexOf('x')
          );
          videoCompressObj.height = fileProcess.info[0].wh.substring(
            fileProcess.info[0].wh.indexOf('x') + 1
          );
          sentGAEvent({
            category: 'Upload',
            action: 'LocalSerSuccess',
          });
          sentGAEvent({
            category: 'compress_add_files',
            action: 'compress_add_files',
            label: `${
              videoCompressObj.name.split('.')[
                videoCompressObj.name.split('.').length - 1
              ]
            }_${(videoCompressObj.size / 1024).toFixed(2)}kb_${
              videoCompressObj.width
            }*${videoCompressObj.height}_${videoCompressObj.frameRate}_${
              videoCompressObj.bitrate
            }`,
          });
          sentGAEvent({
            category: 'compress_add_files',
            action: 'compress_add_duration',
            label: `${new Date().valueOf() - startUploadTime}ms`,
          });
          this.props.onVideoCompressObjChange(videoCompressObj);
          this.setState({ frameRate: fileProcess.info[0].fps });
        }
      } else {
        if (fileResponse.code === 401) {
          Cookies.remove('authorization', { domain: api_domain_config.DOMAIN });
          let hostName = window.location.hostname;
          Cookies.remove('access_token', {
            domain: hostName.substring(
              window.location.hostname.indexOf('.'),
              hostName.length
            ),
          });
          Cookies.remove('access_token_expires_in', {
            domain: hostName.substring(hostName.indexOf('.'), hostName.length),
          });
          window.location.replace(
            `${accountList.get('login')}?redirect=${window.location.href}`
          );
        }
        sentGAEvent({
          category: 'Upload',
          action: 'LocalSerFail',
          label:
            'uploadVideo' +
            '_200_' +
            fileResponse.code +
            '_none_' +
            this.props.tokenId +
            '_none_' +
            fileResponse.msg,
        });
        sentGAEvent({
          category: 'compress_add_files',
          action: 'compress_add_files_fail',
          label: `${(videoCompressObj.size / 1024).toFixed(2)}mb_${
            videoCompressObj.name.split('.')[
              videoCompressObj.name.split('.').length - 1
            ]
          }`,
        });
        this.handleSubmitFail(null, 'upload');
        return false;
      }
      this.setState({
        submitting: false,
        submitStatus: 'waiting',
      });
      this.props.onProcessPercentChange(0);
      this.props.onProcessStepChange(0);
      this.props.onUploadPercentChange(0);
    }
  };

  handleSubmitFail = (error, errorType) => {
    if (errorType !== 'upload' && error !== 'cancel') {
      this.setState({
        submitStatus: 'failed',
      });
    } else if (error !== 'cancel') {
      this.setState({
        uploadFail: true,
      });
      this.props.onVideoCompressObjChange(null);
    }
    this.setState({ submitting: false });
    this.props.onProcessPercentChange(0);
    this.props.onProcessStepChange(0);
    this.props.onUploadPercentChange(0);
  };

  requstVideoCompress = (file_url, data) => {
    const formData = new FormData();
    formData.append('format', data.format);
    formData.append('file_url', file_url);
    formData.append('quality', data.quality);
    formData.append('resolution', data.resolution);
    formData.append('frame_rate', data.frame_rate);
    formData.append('token', this.props.tokenId);
    return new Promise((resolve, reject) => {
      request(`compressVideo`, {
        method: 'post',
        body: formData,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  requestUploadVideoFile = (file) => {
    sentGAEvent({
      category: 'Upload',
      action: 'LocalSerStart',
    });
    sentGAEvent({
      category: 'UploadStart',
      action: '24VC_UploadStart',
    });
    const formData = new FormData();
    formData.append('files[]', file);
    formData.append('token', this.props.tokenId);
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${api_config.API_URL}/uploadVideo`, true);
      xhr.setRequestHeader('authorization', this.props.authorization);
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          let percent = parseInt((event.loaded / event.total) * 100);
          if (this.props.uploadPercent < 100) {
            this.props.onUploadPercentChange(percent);
          } else {
            this.props.onUploadPercentChange(
              percent +
                (this.props.uploadPercent - (this.props.uploadPercent % 100))
            );
          }
        }
      };
      xhr.onerror = () => {
        reject('uploadVideo_' + xhr.status);
      };
      xhr.onabort = () => {
        reject('cancel');
      };
      xhr.upload.onabort = () => {
        reject('cancel');
      };
      xhr.onload = () => {
        resolve(JSON.parse(xhr.response));
      };
      xhr.send(formData);
      this.setState({ uploadXHR: xhr });
      this.props.onUploadXHRChange(xhr);
    });
  };

  getRequestData = () => {
    const { resolution, format, quality, frameRate } = this.state;
    const { width, height } = this.props.videoCompressObj;
    let data = {
      format,
      quality: quality / 100,
      resolution: resolution === 'original' ? `${width}x${height}` : resolution,
      frame_rate: frameRate,
    };
    if (resolution === 'original') {
      data.resolution = `${width}x${height}`;
    } else if (parseInt(width) >= parseInt(height)) {
      let w = resolution.split('x')[0];
      data.resolution =
        w +
        'x' +
        (parseInt(w) / (parseInt(width) / parseInt(height))).toFixed(0);
    } else {
      let h = resolution.split('x')[0];
      data.resolution =
        (parseInt(h) * (parseInt(width) / parseInt(height))).toFixed(0) +
        'x' +
        h;
    }
    return data;
  };

  cancelProcessCallBack = () => {
    this.setState({
      submitting: false,
    });
    this.cancelWork = true;
  };

  goBackToWorkPlace = () => {
    this.setState({
      submitStatus: 'waiting',
    });
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.videoCompressObj !== prevProps.videoCompressObj &&
      !this.props.videoCompressObj
    ) {
      this.setState({
        resolution: 'original',
        quality: 80,
      });
    }
  }

  render() {
    console.log('this.state.submitStatus', this.state.submitStatus);
    const { t } = this.props;
    return (
      <div className='work-cont'>
        {this.state.submitStatus === 'waiting' ? (
          <div className='work-hd'>
            <h1 className='container'>{t('HitPaw Online Video Compressor')}</h1>
            <p className='container'>
              {t(
                'Best video compressor tool to reduce video file size online without losing quality.'
              )}
            </p>
          </div>
        ) : null}
        {!this.props.videoCompressObj ? (
          <Upload
            visible
            accept={this.state.videoAccept}
            isHideUploadProcessCont
            isShowUploadProcess
            addFileCallBack={this.addFileCallBack}
            uploadMaxCount={1}
          />
        ) : this.state.submitStatus === 'waiting' ? (
          <VideoCompressWorkContentFunction
            submitting={this.state.submitting}
            quality={this.state.quality}
            frameRate={this.state.frameRate}
            resolution={this.state.resolution}
            videoCompressObj={this.props.videoCompressObj}
            handleVideoCompressObjChange={this.handleVideoCompressObjChange}
            handleChangeResolution={(resolution) =>
              this.setState({ resolution })
            }
            handleChangeQuality={(quality) => this.setState({ quality })}
            handleChangeFrameRate={(frameRate) => this.setState({ frameRate })}
            handleSubmit={this.handleSubmit}
            cancelProcessCallBack={this.cancelProcessCallBack}
            processText={this.state.processText}
            startTime={this.props.startTime}
          />
        ) : (
          <VideoCompressWorkFinishFunction
            submitStatus={this.state.submitStatus}
            videoCompressAfter={this.state.videoCompressAfter}
            videoCompressObj={this.props.videoCompressObj}
            handleSubmitAgain={() =>
              this.setState({ submitStatus: 'waiting' }, this.handleSubmit)
            }
            goBackToWorkPlace={this.goBackToWorkPlace}
          />
        )}
        <TipSimpleModal
          visible={this.state.uploadFail}
          onCancel={() => {
            this.setState({ uploadFail: false });
          }}
          content='Failed to load!  Get HitPaw Watermark Remover for stable processing.'
        />
      </div>
    );
  }
}

const mapStateToPropos = (state) => ({
  videoCompressObj: state.work.videoCompressObj,
  tokenId: state.common.tokenId,
  uploadPercent: state.work.uploadPercent,
  startTime: state.work.startTime,
  authorization: state.common.authorization,
});

const mapDispatchToProps = (dispatch) => ({
  onVideoCompressObjChange: (videoCompressObj) =>
    dispatch(actions.onVideoCompressObjChange(videoCompressObj)),
  onUploadPercentChange: (uploadPercent) =>
    dispatch(actions.onUploadPercentChange(uploadPercent)),
  onUploadXHRChange: (uploadXHR) =>
    dispatch(actions.onUploadXHRChange(uploadXHR)),
  onProcessStepChange: (processStep) =>
    dispatch(actions.onProcessStepChange(processStep)),
  onProcessPercentChange: (processPercent) =>
    dispatch(actions.onProcessPercentChange(processPercent)),
  onStartTimeChange: (startTime) =>
    dispatch(actions.onStartTimeChange(startTime)),
  onPurchaseModalObjChange: (purchaseModal) =>
    dispatch(actions.onPurchaseModalObjChange(purchaseModal)),
});

export default connect(
  mapStateToPropos,
  mapDispatchToProps
)(withTranslation(['videoCompress', 'common'])(VideoCompressWork));
